// angularjs
import angular from 'angular';
import angularRedux from '@buildium/angular-redux';
import jQuery from 'jquery';

import { PublicAngularJSRoutingModule } from './app-routing.module.ajs';
import { BuildiumCacheModule } from '../../../../src/shared/cache.module';
import { environment } from '../environments/environment';
import { downgradeInjectable } from '@angular/upgrade/static';
import { NotifyShimService } from './page/notify-shim-service';
// In general, we should NOT be importing services from other apps, but these will eventually come from a shared package
import { PageTitleService } from '../../../../src/app/services/page-title.service';
import { PageLoadingService } from '../../../../src/app/services/page-loading.service';
import { ToastMessageStateService } from '../../../../src/app/core/toast-message/services/toast-message.state.service';
import { FeatureFlagService } from '../../../../src/app/services/feature-flag.service';
import { SiteChromeService } from '../../../../src/app/core/app-shell/services/site-chrome.service';

// feature modules
// NOTE: to lazy load a feature module, do not import here
// use angularJsFeatureModules to register the module in app-routing.module.ajs.ts

jQuery.migrateMute = true;

// suppress ocLazyLoad error, due to known conflict between angular's UpgradeModule and ocLazyLoad
// https://github.com/ocombe/ocLazyLoad/issues/250#issuecomment-948309569
Object.defineProperty(angular.element.prototype, 'className', {
    get() {
        return this[0] === document ? 'ng:app:ng' : undefined;
    }
});

export const PublicAngularJSModule = angularRedux.createApp('buildium-public', [
    PublicAngularJSRoutingModule,

    // TODO - remove. BuildiumCacheModule shouldn't be needed, once the app shell is acting like a SPA
    BuildiumCacheModule.name,
])
    .factory('PageTitleService', downgradeInjectable(PageTitleService))
    .factory('PageLoadingService', downgradeInjectable(PageLoadingService))
    .factory('ToastMessageStateService', downgradeInjectable(ToastMessageStateService))
    .factory('FeatureFlagService', downgradeInjectable(FeatureFlagService))
    .factory('SiteChromeService', downgradeInjectable(SiteChromeService))
    .service('Notify', NotifyShimService)
    .name;

if (!environment.production) {
    // eslint-disable-next-line no-console
    console.debug('[PublicAngularJSModule] AngularJS loaded, version', angular.version.full);
}
